import { VStack } from '@genial/components';
import React from 'react';

import { IOProductItem } from '../../../../store/customerDetail/SecuritiesTransfer/types';
import { DynamicIOProductTable } from '../DynamicIOProductTable';

import {
  dividendsColumns,
  equitiesIncomingColumns,
  equitiesOutgoingColumns,
  fixedIncomeIncomingColumns,
  fixedIncomeOutgoingColumns,
  fundsIncomingColumns,
  fundsOutgoingColumns,
  treasuryColumns,
} from './constants';

export interface IOProductTablesProps {
  hasSelfOrigin: boolean;
  onPressItem?: (item: IOProductItem) => void;
  detailsDisabled?: boolean;
  fixedIncome?: IOProductItem[];
  funds?: IOProductItem[];
  equities?: IOProductItem[];
  dividends?: IOProductItem[];
  treasury?: IOProductItem[];
}

export const IOProductTables: React.FC<IOProductTablesProps> = ({
  hasSelfOrigin,
  onPressItem,
  fixedIncome = [],
  funds = [],
  equities = [],
  dividends = [],
  treasury = [],
}) => {
  const fixedIncomeColumns = hasSelfOrigin
    ? fixedIncomeOutgoingColumns
    : fixedIncomeIncomingColumns;
  const fundsColumns = hasSelfOrigin ? fundsOutgoingColumns : fundsIncomingColumns;
  const equitiesColumns = hasSelfOrigin ? equitiesOutgoingColumns : equitiesIncomingColumns;

  return (
    <VStack>
      <DynamicIOProductTable
        title="Renda fixa"
        titleDataKey="name"
        data={fixedIncome}
        columns={fixedIncomeColumns}
        keyExtractor={(item) => item.id}
        onPressItem={onPressItem}
      />
      <DynamicIOProductTable
        title="Fundos"
        titleDataKey="name"
        data={funds}
        columns={fundsColumns}
        keyExtractor={(item) => item.id}
        onPressItem={onPressItem}
      />
      <DynamicIOProductTable
        title="Ações"
        titleDataKey="name"
        data={equities}
        columns={equitiesColumns}
        keyExtractor={(item) => item.id}
        onPressItem={onPressItem}
      />
      <DynamicIOProductTable
        title="Proventos"
        titleDataKey="name"
        data={dividends}
        columns={dividendsColumns}
        keyExtractor={(item) => item.id}
        onPressItem={onPressItem}
      />
      <DynamicIOProductTable
        title="Tesouro"
        titleDataKey="name"
        data={treasury}
        columns={treasuryColumns}
        keyExtractor={(item) => item.id}
        onPressItem={onPressItem}
      />
    </VStack>
  );
};
